module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.userLoggedIn) ? _c('div', [_c('p', [_vm._v("You must be logged in to use this page.")])]) : _vm._e(), _vm._v(" "), (_vm.userLoggedIn) ? _c('div', [_c('p', [_vm._v("Send a message to the author:")]), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e(), _vm._v(" "), (_vm.sendState === 'sending') ? _c('div', [_c('Loader', {
    attrs: {
      "size": 'large'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sendState !== 'sending') ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "u-full-width",
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send Message")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc91b05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Email.vue
// module id = 268
// module chunks = 1